var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 393"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 1.5,
    cy: 11.5,
    r: 1.5,
    fill: "#010314",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 1.5,
    cy: 6.5,
    r: 1.5,
    fill: "#010314",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#010314",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dot);
export default __webpack_public_path__ + "static/media/3-dot.613dd93ade3b25ecae482590956c6ddd.svg";
export { ForwardRef as ReactComponent };